import { render, staticRenderFns } from "./ClientStatic.vue?vue&type=template&id=67e91c98&scoped=true&"
import script from "./ClientStatic.vue?vue&type=script&lang=js&"
export * from "./ClientStatic.vue?vue&type=script&lang=js&"
import style0 from "./ClientStatic.vue?vue&type=style&index=0&id=67e91c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e91c98",
  null
  
)

export default component.exports